import React from "react";
import Typography from ".";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Colors } from "utils/colors";

interface IProps {
  to: string;
  text: string;
  color?: string;
  size?: string;
  m_size?: string;
  underline?: boolean;
  hoverColor?: string;
  target?: "_blank" | "_self";
}
const LinkText = ({
  text,
  to,
  color = Colors.yellow400,
  size = "",
  m_size = size,
  underline = true,
  hoverColor = color,
  target = "_blank"
}: IProps) => {
  return (
    <Text to={to} target={target} color={color} hovercolor={hoverColor}>
      <Typography
        decoration={underline ? "underline" : "unset"}
        size={size}
        m_size={m_size}
      >
        {text}
      </Typography>
    </Text>
  );
};

export default LinkText;

const Text = styled(Link)<{ color: string; hovercolor: string }>`
  all: unset;
  cursor: pointer;
  color: ${(props) => props.color};
  transition: color 0.3s ease;
  position: relative;
  &:hover {
    color: ${(props) => props.hovercolor};
  }
`;
